import { Component } from '@angular/core';

@Component({
  selector: 'dk-generic-seed-icon',
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M10.3329 3.60059L7 0V4.36182C7 5.05725 7.25908 5.72604 7.72332 6.22682L10.3335 9.04552V3.60059H10.3329Z"
        fill="#545454" />
      <path
        d="M10.332 9.07661L13.6655 5.47656V9.83838C13.6655 10.5338 13.4064 11.2026 12.9422 11.7034L10.332 14.5221V9.07661Z"
        fill="#545454" />
      <path
        d="M10.3335 14.5532L7 10.9531V15.3149C7 16.0104 7.25908 16.6792 7.72332 17.1799L10.3335 19.9986V14.5532Z"
        fill="#545454" />
    </svg>
  `,
  styles: [
    `
      svg {
        fill: currentColor;
      }
    `,
  ],
})
export class SeedGenericIconComponent {}
